import CurrentMySchedule from "./current-my-schedule";

const Offers: React.FC = () => {
  return (
    <div>
      <div className="mt-1">
        <h3 className="text-[22px] font-normal text-[#1E2F65]">
        Schedule Management
        </h3>
        <CurrentMySchedule />
      </div>
    </div>
  );
};

export default Offers;
